import React from "react";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
// import mainLogo from './../_img/logo-csmile.png';
import { genURL } from './../_getjson.js';
import axios from 'axios'
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
import Snackbar from './../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
const Codear = "CSAR/ARCode?arcode=";
const Namear = "CSAR/ARName?arname=";
require("./../_css/PopUpOther.css");
export const OnGetARcode = async (arcode) => {
    this.setState({ openBackdrop: true })
    var url = "CSAR/ARCode?arcode=" + arcode + "&user=" + localStorage.getItem("Username");
    console.log(genURL(url));
    await axios.get(genURL(url), { timeout: 60000 }).then(res => {
        var dataArray = [res.data[0].CODE, res.data[0].NAMETH];
        this.setState({ creditType: res.data[0].CREDITCODE });
        this.setState({ openBackdrop: false })
        return dataArray;
    }).catch(error => {
        this.setState({ openBackdrop: false })
        this._chkload("Error" + error);
    });
}
export default class Popup extends React.Component {
    constructor(props) {
        super(props);
        this.CustomerName = React.createRef();
        this.state = {
            openBackdrop: false,
            messagealert: "",
        }
    }
    componentDidMount() {
        this.setState({
            selected: "1",
            autoClose: 3600,
        })
        this.getItemar("")
    }
    onKeyUp = (e) => {
        if (e.key === 'Enter') {
            var txt = e.target.value;
            this.getItemar(txt);
        }
    }
    onClickSearch = () => {
        var txt = this.CustomerName.current.value;
        this.getItemar(txt);
    }
    getItemar = async (data1) => {
        let urlmain;
        if (this.state.selected === "0") {
            urlmain = Codear;
        } else {
            urlmain = Namear;
        }
        this.setState({ openBackdrop: true })
        var url = urlmain + data1 + "&user=" + localStorage.getItem("Username") + "&top=300"
        let dataArray = []
        console.log("getItemar:::", genURL(url));
        await axios.get(genURL(url), { timeout: 60000 }).then(res => {
            if (res.data === undefined) {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ไม่สามารถเชื่อมต่อฐานข้อมูลได้" })
                return
            }
            for (let i = 0; i < res.data.length; i++) {
                if (res.data.length > 0) {
                    //console.log(i,"for",res.data[i].SUBGROUP1); 
                    dataArray[i] = {
                        number: i + 1,
                        Customercode: res.data[i].CODE,
                        Customername: res.data[i].NAMETH,
                        Address: res.data[i].ADDRESSTH,
                        Contact: res.data[i].NAMETH,
                        Phone: res.data[i].TELEPHONE,
                        Creditcode: res.data[i].CREDITCODE,
                        Texttype: res.data[i].TAXTYPE,
                        _accountcdoe: res.data[i].ACCOUNTCODE,
                        _Prefis: res.data[i].Prefis,
                        _Arname: res.data[i].Arname,
                        _Surname: res.data[i].Surname,
                        _armaingroup: res.data[i].MAINGROUP,
                        _arsubgroup1: res.data[i].SUBGROUP1,
                        _Arname2: res.data[i].Arname2,
                    }
                }
            }
        }).then(async _ => {
            await this.setState({ col: dataArray })
            this.setState({ openBackdrop: false })
        }).catch(error => {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "Error" + error })
            //console.log("Error" + error);
            this.setState({ openBackdrop: false })
        });
    }
    onSelectRow = (data) => {
        this.props.Get_PopUparcode(data.Customercode, data.Customername, data.Creditcode, data.Texttype, data.Address, data._accountcdoe, data._Prefis, data._Arname, data._Surname, data._armaingroup, data._arsubgroup1, data._Arname2);
        this.props.closePopup();
    }
    render() {
        return (
            <div className='popup' >
                <Backdrop open={this.state.openBackdrop} />
                <div className='popup_inner'>
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1"> <i className="fas fa-search" > ค้นหาลูกค้า </i> </div>
                        <div className="PopUpOtherDivH2" onClick={this.props.closePopup}><i className="fas fa-times"></i></div>
                    </div>
                    <div className="panel-body divTable" align="left">
                        <div className="DivTable">
                            <div className="form-inline">
                                <div className="form-group mb-2">
                                    <input type='radio' id='Choice-1' name='myRadio' value='0'
                                        checked={this.state.selected === '0'} onChange={(e) => this.setState({ selected: e.target.value })} /><span className="choiceSty">&nbsp;ค้นหาจากรหัส&nbsp;&nbsp;&nbsp;</span>
                                    <input type='radio' id='Choice-2' name='myRadio' value='1'
                                        checked={this.state.selected === '1'} onChange={(e) => this.setState({ selected: e.target.value })} /><span className="choiceSty">&nbsp;ค้นหาจากชื่อ&nbsp;</span>
                                </div>
                            </div>
                        </div>
                        <div className="input-group width-grop">
                            <input type="text" className="form-control" placeholder="กรอกคำค้นหา" onKeyUp={this.onKeyUp} ref={this.CustomerName} />
                            <span className="input-group-addon txt-img icon"><i className="fas fa-search" onClick={this.onClickSearch}></i></span>
                            <span className="input-group-addon txt-img icon"> <i className="fas fa-sync-alt" onClick={() => { this.componentDidMount() }}></i></span>
                        </div>
                        <BootstrapTable
                            data={this.state.col}
                            height="700"
                            options={{
                                onRowClick: this.onSelectRow,
                                noData: "...."
                            }}
                            hover condensed>
                            <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" expandable={true} dataAlign="center" width="40" dataField='number' dataSort></TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="200" dataField='Customercode' isKey columnTitle> รหัสลูกค้า</TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="200" dataField='Customername' columnTitle> ชื่อลูกค้า</TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="500" dataField='Address' columnTitle > ที่อยู่</TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='Phone' > โทรศัพท์</TableHeaderColumn>
                        </BootstrapTable>

                    </div>
                </div>
                <Snackbar place="br"
                    color={this.state.color}
                    icon={this.state.icon}
                    autoClose={this.state.autoClose}
                    message={this.state.messagealert}
                    open={this.state.opensnackbar}
                    closeNotification={() => { this.setState({ opensnackbar: false }) }}
                    close />
            </div >
        );
    }
}